export default __webpack_public_path__ + "static/media/gun-dogum-batım.6afe1fff.png";